function showError(message) {
  window.dispatchEvent(new CustomEvent('show-toast-notification', {
    detail: { type: 'alert', message }
  }));
}

/** Refresh the saved eligibility and reload the current page's server-rendered state. */
export async function recheckEligibility(button, {
  fetchRequest = window.fetch.bind(window), reload = () => window.location.reload()
} = {}) {
  if (button.disabled) return;

  const label = button.textContent;
  const wasFocused = document.activeElement === button;
  button.disabled = true;
  button.textContent = button.dataset.checkingLabel;
  button.setAttribute('aria-busy', 'true');

  try {
    const response = await fetchRequest(button.dataset.recheckUrl, {
      method: 'POST', credentials: 'same-origin', redirect: 'error',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
      }
    });
    const data = await response.json();
    if (!response.ok || !['enabled', 'disabled', 'unknown'].includes(data.eligibility)) {
      const message = Array.isArray(data.errors) && data.errors.length > 0 &&
        data.errors.every(item => typeof item === 'string')
        ? data.errors.join(' ') : button.dataset.errorMessage;
      showError(message);
      return;
    }
    const confirmed = data.eligibility === 'enabled' && data.last_attempt_outcome === 'succeeded';
    const message = confirmed ? button.dataset.successMessage
      : data.eligibility === 'disabled' ? button.dataset.disabledMessage : button.dataset.unconfirmedMessage;
    sessionStorage.setItem('flash_message', JSON.stringify([confirmed ? 'notice' : 'warning', message]));
    reload();
  } catch (_) {
    showError(button.dataset.errorMessage);
  } finally {
    button.disabled = false;
    button.textContent = label;
    button.removeAttribute('aria-busy');
    // Disabling a focused button can move focus to the body during the request.
    if (wasFocused && button.isConnected && document.activeElement === document.body) {
      button.focus({ preventScroll: true });
    }
  }
}

document.addEventListener('click', event => {
  const button = event.target.closest('[data-apple-eligibility-recheck]');
  if (button) recheckEligibility(button);
});
